/**
 * @description  我的考试--学生端
 * @author lwb
 */

const state = {
  // 考试信息
  examInfo: () => {},
  // 试卷详情
  testPaperDetail: () => {},
  // 试卷题目
  questions: () => [],
};
const getters = {};
const mutations = {
  // 设置考试信息
  setExamInfo(state, exam) {
    state.examInfo = exam;
  },
  // 设置试卷详情
  setTestPaperDetail(state, info) {
    state.testPaperDetail = info;
  },
  // 设置试卷题目
  setQuestions(state, options) {
    state.questions = options;
  },
};
const actions = {};

export default { state, getters, mutations, actions };
